var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-btn",
    {
      staticClass: "shadow-sm",
      class: [
        _vm.bgColor,
        _vm.textColor,
        _vm.textHover,
        _vm.bgHover,
        _vm.customClass,
      ],
      attrs: {
        block: _vm.block,
        small: _vm.small,
        "x-small": _vm.xSmall,
        large: _vm.large,
        color: _vm.color,
        depressed: _vm.depressed,
      },
    },
    [
      _vm.iconName
        ? _c(
            "v-icon",
            {
              staticClass: "transition-none",
              class: [_vm.iconMr],
              attrs: { small: _vm.smallIcon },
            },
            [_vm._v(_vm._s(_vm.iconName))]
          )
        : _vm._e(),
      _vm._v(" " + _vm._s(_vm.text) + " "),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }